import { call, take, cancelled, put } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';

import * as appointmentList from '../requests/appointment-list-req';
import { CHECK_OVERDUE_INTERVAL_TIME } from '../config';

function makeInterval() {
  return eventChannel(emitter => {
    const iv = setInterval(() => emitter(true), CHECK_OVERDUE_INTERVAL_TIME);
    return () => clearInterval(iv);
  });
}

export default function* intervalSaga() {
  const chan = yield call(makeInterval);

  try {
    while (true) {
      yield take(chan);
      yield put(appointmentList.actions.markOverdue());
    }
  } finally {
    if (yield cancelled()) {
      chan.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/interval-saga.js